<div class="miles-card padded" *ngIf="!isEditing">
    <h4>{{ _sharedEntitiesConfig.EntityNamePluralized }}</h4>
    <ul class="list-group">
        <li *ngFor="let entity of entitiesArray" (click)="entitySelected(entity)" class="list-group-item">
            <div [innerHTML]="_sharedEntitiesConfig.getRow(entity)"></div>
        </li>
    </ul>
    <i *ngIf="!entitiesArray.length">No {{ _sharedEntitiesConfig.EntityNamePluralized }}</i>
    <div [hidden]="!canAdd" class="fab-wrap">
        <button type="button" class="btn btn-primary btn-fab-md btn-fab-center" (click)="addEntity()">
            <span class="fa fa-plus"></span>
        </button>
    </div>
    <div class="pull-right max-of-total">
        <span>{{ max() > total() ? total() : max() }} of {{ total() }}</span>
    </div>
</div>
<div class="miles-form padded" *ngIf="isEditing">
    <h4>
        {{ (selectedEntity.Id > 0 ? 'Edit ' : 'Add ') + _sharedEntitiesConfig.EntityName }}
    </h4>
    <mt-dynamic-form [config]="formObject" (submitted)="save($event)" (formCreated)="formCreated($event)">
        <button type="submit" Class="btn btn-flat btn-success">Save</button>
        <button type="button" Class="btn btn-flat btn-default" (click)="selectedEntity = null">Cancel</button>
        <button
            *ngIf="selectedEntity['GrantAccessToPortal'] && selectedEntity['UserId'] > 0"
            type="button"
            Class="btn btn-flat btn-info"
            (click)="revokeAccess(selectedEntity['UserId'])"
        >
            Revoke Access
        </button>
        <button type="button" Class="pull-right btn btn-flat btn-danger" (click)="delete()">Archive</button>
        <button *ngIf="showAdditionalInfoButton" type="button" Class="pull-right btn btn-flat btn-default" (click)="additionalInfo()">
            {{ additionalInfoButtonOverride ? additionalInfoButtonOverride : 'Additional Info' }}
        </button>
    </mt-dynamic-form>
</div>
